import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { PreviousRouteService } from "src/commons/services/previousRoute.service";
import { AdminRouter } from "./admin.router";
import { reducers } from "./state/admin.selectors";

@NgModule({
  imports: [
    AdminRouter,
    StoreModule.forFeature('admin', reducers),
  ],
  providers: [PreviousRouteService],
  declarations: []
})
export class AdminScreenModule { }